// Shared worker instance used by both DicomLoader and SliceViewer
const worker = new Worker(new URL('./Worker.js', import.meta.url));

export default worker;
